var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-code-container"},[_c('div',{staticClass:"qr-code-name"},[_vm._v(_vm._s(_vm.qrCodeName))]),_c('img',{staticClass:"qr-code-image",attrs:{"src":_vm.qrCodeUrl,"alt":"二维码图片"}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tips-container"},[_c('p',{staticClass:"tip-text"},[_vm._v("长按识别二维码，关注公众号，开始服务")]),_c('p',{staticClass:"tip-text"},[_vm._v("首次登录，需点击右下角“使用完整服务”")])])
}]

export { render, staticRenderFns }